import React from 'react'
import { FormattedMessage } from 'react-intl'

import Card from 'legacy/components/Card/Card'

interface Props {
  titleId: string
  mountCollapsed?: boolean
  renderAction?: () => React.ReactNode
}

class FormSection extends React.Component<Props> {
  render() {
    const { renderAction, children, titleId, mountCollapsed } = this.props

    return (
      <Card margin="0 0 20px 0" collapsible mountCollapsed={mountCollapsed}>
        <Card.Header title={<FormattedMessage id={titleId} />}>
          {renderAction && renderAction()}
        </Card.Header>
        <Card.Body>{children}</Card.Body>
      </Card>
    )
  }
}

export default FormSection
